// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { EditBmkComponent } from '@project/components/article/edit-bmk/edit-bmk.component';
import { PickProjectVersionComponent } from '@project/components/project/pick-project-version/pick-project-version.component';
import { WindowService } from '@shared/window/window.service';
import { ProjectDirectOrderComponent } from './project/project-order/project-direct-order.component';
import { FinalizationPreselectionVO, ProjectFinalizationInfoVO, ProjectHeadVO, ProjectOptionDefVO, ProjectOptionVO, ProjectSaveInfoVO, ProjectVO } from '../model/vo/project.vo';
import { ModalSaveProjectComponent, SaveProjectPopupData } from './project/save/save.component';
import { ProjectGroupVO } from '../model/vo/project-group.vo';
import { EditProjectGroupComponent } from './project/edit-project-group/edit-project-group.component';
import { CustomArticleInfoVO, CustomArticleLibraryVO } from './article/model/vo/custom-article.vo';
import { PasteArticleComponent } from './article/paste-article/paste-article.component';
import { CustomArticleListComponent } from './article/custom-article/list/custom-article-list.component';
import { ConfigureCustomArticleMode } from './article/custom-article/configure/configure-custom-article-mode';
import { ArticleUsageVO, ArticleVO } from '@article/model/vo/article.vo';
import { ConfigureCustomArticleComponent } from './article/custom-article/configure/configure-custom-article.component';
import { PrintLabelingComponent } from './label/print-labeling/print-labeling.component';
import { CopyProjectOperationProperties, CopyProjectPopupComponent } from './project/copy/copy.component';
import { ModalSaveProjectPopupComponent } from './project/save/project-save-popup.component';
import { SwitchingRailsProblemsComponent } from '@configuration/wizard/switching-rails-problems/switching-rails-problems.component';
import { SelectProjectForCSVComponent } from './report/select-project-for-csv/select-project-for-csv.component';
import { MoveArticleComponent } from './article/move-article/move-article.component';
import { ShareProjectLinkComponent } from './project/share-project-link/share-project-link.component';
import { CadExportComponent } from './import-export/cad-export/cad-export.component';
import { ChoiceActionLocalBackupComponent } from './import-export/choice-action-local-backup/choice-action-local-backup.component';
import { ChoiceActionCaeComponent } from '../cae/choice-action-cae/choice-action-cae.component';
import { PermissionsComponent } from './permissions/permissions.component';
import { ChoiceActionManualArticlenoComponent } from './project/finalize-project/choice-action-manual-articleno/choice-action-manual-articleno.component';
import { CoverlabelStripSettingsComponent } from './label/cover-label-strip-settings/cover-label-strip-settings.component';
import { SettingsComponent } from './project/settings/settings.component';
import { ConfSettingsComponent } from './config/settings/edit-conf-settings/conf-settings.component';
import { EditConfOptionComponent } from './config/settings/edit-conf-option/edit-conf-option.component';
import { ProjectOptionDefComponent } from './project/project-option-def/project-option-def.component';
import { EditProjectOptionDefItemComponent } from './project/project-option-def/edit/edit-project-option-def-item.component';
import { EditNoticeComponent } from './project/project-option-def/edit-notice/edit-notice.component';
import { WireBridgeInfoComponent } from './project/wire-bridge-info/wire-bridge-info.component';
import { SelectArticleComponent } from './article/select-article/select-article.component';
import { EditBlockingZoneComponent } from './article/edit-blocking-zone/edit-blocking-zone.component';
import { EditEmptyZoneComponent } from './article/edit-empty-zone/edit-empty-zone.component';
import { EditNBusbarComponent } from './article/edit-n-busbar/edit-n-busbar.component';
import { RailPropertiesConfiguration } from './project/rail-properties/rail-properties-configuration';
import { RailPropertiesComponent } from './project/rail-properties/rail-properties.component';
import { ITableProvider } from './label/label-editor/table-provider';
import { LabelEditorAssistantComponent, LabelEditorPENOptions } from './label/label-editor/assistant/label-editor-assistant.component';
import { ProjectLoadingOutdatedArticlesComponent } from './article/outdated-articles/project-loading-outdated-articles.component';
import { ReassignComponent } from './project/reassign/reassign.component';
import { EditProjectVersionComponent, EditProjectVersionResult } from './project/edit-project-version/edit-project-version.component';
import { EditProjectNameComponent } from './project/edit-project-name/edit-project-name.component';
import { ProjectVersionHistoryComponent } from './project/project-version-history/project-version-history.component';
import { CompareItemListsComponent } from './project/compare-item-lists/compare-item-lists.component';
import { ExportPrintFileComponent, ExportType } from './import-export/export-print/export-print-file.component';
import { ChoiceActionExportPrintComponent } from './import-export/choice-action-export-print/choice-action-export-print.component';
import { ArrayUtils } from '@shared/util/array-utils';
import { DrillingHoleWizardComponent } from '../actions/drilling-hole/wizard/drilling-hole-wizard.component';
import { WaitForProServeProjectImportPopupComponent } from './import-export/wait-for-proServe-project-import-popup/wait-for-proServe-project-import-popup.component';
import { IOArticleSettingsTabComponent } from './article/io-article-settings-tab/io-article-settings-tab.component';
import { EditDescriptionComponent } from './article/io-article-settings-tab/edit-description/edit-description.component';
import { FinalizeProjectComponent } from './project/finalize-project/finalize-project.component';
import { FinalizeLegacyProjectComponent } from './project/finalize-project/finalize-legacy-project/finalize-legacy-project.component';
import { FinalizeProjectRepetitionComponent } from './project/finalize-project/finalize-project-repetition/finalize-project-repetition.component';
import { ChooseFinalizationActionComponent } from './project/finalize-project/choose-finalization-action/choose-finalization-action.component';
import { EditProjectArticleNumberComponent } from './project/finalize-project/edit-project-article-number/edit-project-article-number.component';
import { MultipleQuoteRequestData } from './request/multiple-quote-request-data';
import { ProjectRequestApprovalComponent } from './request/project-request-approval/project-request-approval.component';
import { ProjectRequestQuoteTypeComponent } from './request/project-request-quote-type/project-request-quote-type.component';
import { ProjectRequestPriceCalculationComponent } from './request/project-request-price-calculation/project-request-price-calculation.component';
import { ProjectRequestComponent } from './request/project-request.component';
import { ProjectRequestUnavailableArticlesComponent } from './request/project-request-unavailable-articles/project-request-unavailable-articles.component';
import { ChooseFinalizationPreselectionComponent } from './project/finalize-project/choose-preselection/choose-finalization-preselection.component';
import { ElbridgeComponent } from './project/elbridge/elbridge.component';
import { ElbridgeInfoComponent } from './project/elbridge/info/elbridge-info.component';
import { SelectCableFedSidePopupComponent } from './project/assistants/select-cable-fed-side/select-cable-fed-side.component';
import { UserModel } from '@user/model/user.model';
import { AlertHelper } from '@shared/alert/alert.helper';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FinalizationPreviewApprovalComponent } from './report/select-project-for-csv/finalization-preview-approval.component';
import { ReportVO } from '../model/vo/report.vo';
import { ReportGenerationPropertyVO } from './article/model/vo/property.vo';
import { SelectProjectReportComponent } from './report/select-project-for-csv/select-project-report.component';
import { SelectCsvReportComponent } from './report/select-project-for-csv/select-csv-report.component';
import { EditDrillingHoleMode } from '../actions/drilling-hole/edit-drilling-hole.mode';
import { DrillingHoleInfo } from '@3d-scene/model3d/util/drillinghole/drilling-hole-info';
import { ExportEshopWatchlistComponent } from './project/eshop-watchlist/export-eshop-watchlist/export-eshop-watchlist.component';
import { CorruptArticleAction, ProjectLoadingCorruptArticlesComponent } from './article/project-loading-corrupt-articles/project-loading-corrupt-articles.component';
import { MountingRailAssistantBaseSettingsComponent } from './project/assistants/mounting/mounting-rail/mounting-rail-assistant-base-settings/mounting-rail-assistant-base-settings.component';
import { Log } from '@shared/debug/log';
import { ChangeBaseArticleComponent } from './project/change-base-article/change-base-article.component';
import { DyeConnectionComponent } from './article/dye-connection/dye-connection.component';
import { ColorSelectionOption } from '@configuration/wizard/models/wizard-model.interface';
import { CaeData } from '../cae/cae-data.service';
import { PreferredSamplesModalComponent } from '../preferred-samples-modal/preferred-samples-modal.component';
import { ConfigurationConsistentSamplesAction, ConfigurationConsistentSamplesComponent } from '../configuration-consistent-samples/configuration-consistent-samples.component';
import { CsvImportOptionsComponent } from '../csv/csv-import-options/csv-import-options.component';
import { CaeImportErrorCollector } from '@configuration/assistants/cae-assistant/cae-import-error-collector';
import { CsvResultComponent } from '../csv/csv-result/csv-result.component';

@Injectable({
  providedIn: 'root'
})
export class ProjectComponentPresenter {

  constructor(private windowService: WindowService,
              private userModel: UserModel,
              private alertHelper: AlertHelper,
  ) {}

  public openProjectDirectOrderDialog(): void {
    this.windowService.showModalMd(ProjectDirectOrderComponent);
  }

  public openProjectSaveRequest(
    projectSaveInfo: ProjectSaveInfoVO,
    showSaveAsNewProject: boolean = false,
    isEditProjectVersionPopupAlreadyOpened: boolean = false
  ): Promise<SaveProjectPopupData> {
    return this.windowService.showModalFinish(ModalSaveProjectComponent,
      {
        initialState: {
          showSaveAsNewProject,
          projectSaveInfo,
          isEditProjectVersionPopupAlreadyOpened,
        },
      });
  }

  public async openOverwriteProjectVersion(): Promise<number | undefined> {
    return this.windowService.showModalFinish(PickProjectVersionComponent, {
      class: 'modal-lg',
      initialState: {
        title: 'overwriteProjectVersion.title',
        message: 'overwriteProjectVersion.message',
        submitButtonText: 'global.label.overwrite',
      }
    });
  }

  public openEditProjectGroupPopup(
    title: string,
    groupType: number,
    projectGroup: ProjectGroupVO,
    parentGroup: ProjectGroupVO,
    isArticleProjectGroup: boolean = false,
    isHidden: boolean = false
  ): Promise<ProjectGroupVO> {
    return this.windowService.showModalFinish(EditProjectGroupComponent, {
      initialState: {
        title,
        groupType,
        projectGroup,
        parentGroup,
        isArticleProjectGroup,
        isHidden,
      },
    });
  }

  public openPasteArticleDialog(
    articleTypeId?: number,
    customArticleInfo?: CustomArticleInfoVO,
    isPasteOperation: boolean = false,
    configureArticleLength: boolean = true,
    showRepeatStepper: boolean = false
  ): void {
    this.windowService.showModal(PasteArticleComponent, {
      class: `modal-md`,
      initialState: {
        articleTypeId,
        customArticleInfo,
        isPasteOperation,
        configureArticleLength,
        showRepeatStepper,
      },
    });
  }

  public openCustomArticleList(library: CustomArticleLibraryVO, readonly = false): Promise<void> {
    return this.windowService.showModalFinish(CustomArticleListComponent, {
      initialState: {library, readonly},
    });
  }

  public openCustomArticleDialog(
    configureCustomArticleMode: ConfigureCustomArticleMode,
    customArticleLibrary?: CustomArticleLibraryVO,
    customArticleInfo?: CustomArticleInfoVO,
    articleUsageVO?: ArticleUsageVO,
    articleAlreadyExists: boolean = false
  ): Promise<CustomArticleInfoVO | undefined> {
    return this.windowService.showModalFinish(ConfigureCustomArticleComponent, {
      initialState: {
        configureCustomArticleMode: configureCustomArticleMode,
        customArticleLibrary: customArticleLibrary,
        customArticleInfo: customArticleInfo,
        customArticleUsage: articleUsageVO,
        articleAlreadyExists: articleAlreadyExists
      },
    });
  }

  public openPrintLabelingPopup(isLabelMaterialSelectionAvailable: boolean = true, isSaveOperationAvailable: boolean = true): void {
    this.windowService.showModal(PrintLabelingComponent, {
      class: `modal-md`,
      initialState: {isLabelMaterialSelectionAvailable, isSaveOperationAvailable},
    });
  }

  public openMountingRailAssistantBaseSettings(): void {
    this.windowService.showModalMdFinish(MountingRailAssistantBaseSettingsComponent);
  }

  public async openCopyProjectPopup(itemToCopy: ProjectGroupVO | ProjectHeadVO): Promise<CopyProjectOperationProperties> {
    const result = await this.windowService.showModalFinish(CopyProjectPopupComponent, {
      initialState: {
        itemToCopy
      },
    });
    if (result) {
      return result;
    } else {
      throw Error('CopyComponent action was cancelled');
    }
  }

  public openSaveProjectPopUp(): Promise<boolean> {
    return this.windowService.showModalFinish(ModalSaveProjectPopupComponent);
  }

  public openSwitchingRailsProblemsPopup(unconnectableArticlesToShow: ArticleVO[]): void {
    this.windowService.showModal(SwitchingRailsProblemsComponent, {
      class: `modal-md`,
      initialState: {unconnectableArticlesToShow},
    });
  }

  public openSelectProjectForCSVPopup() {
    this.windowService.showModal(SelectProjectForCSVComponent);
  }

  public openMoveArticleDialog(): void {
    this.windowService.showModal(MoveArticleComponent, {
      class: `modal-md`,
    });
  }

  public openShareProjectLinkPopup(
    projectId: number,
    projectVersion: number,
    modificationDateServerTimeStamp: string,
    articleNumberLong: string,
    projectName: string
  ) {
    this.windowService.showModal(ShareProjectLinkComponent, {
      class: `modal-md`,
      initialState: {projectId, projectVersion, modificationDateServerTimeStamp, articleNumberLong, projectName},
    });
  }

  public openCadExportPopup(): void {
    this.windowService.showModal(CadExportComponent, {
      class: `modal-md`,
    });
  }

  public openExportToWatchlistDialog() {
    return this.windowService.showModalMdFinish(ExportEshopWatchlistComponent);
  }

  public openPopupActionWithWsp(): void {
    this.windowService.showModal(ChoiceActionLocalBackupComponent);
  }

  public openPopupActionWithCae(): void {
    this.windowService.showModal(ChoiceActionCaeComponent);
  }

  public openPermissionDialog(): void {
    this.windowService.showModal(PermissionsComponent, {
      class: 'modal-fz',
    });
  }

  public openChoiceActionManualArticleNoPopup(articleNo: string): Promise<boolean> {
    return this.windowService.showModalFinish(ChoiceActionManualArticlenoComponent, {
      initialState: {
        articleNo: articleNo
      }
    });
  }

  public openCoverlabelStripSettingsPopup(articleUsage: ArticleUsageVO | undefined): void {
    if (!articleUsage) {
      this.windowService.showModal(CoverlabelStripSettingsComponent, {
        class: `modal-sm`,
        initialState: {
          articleUsage,
        },
      });
    }
  }

  public openEditProjectSettingsComponent(projectGroup: ProjectGroupVO, isArticleProjectGroup: boolean): Promise<ProjectGroupVO> {
    return this.windowService.showModalFinish(SettingsComponent, {
      initialState: {
        projectGroup,
        isArticleProjectGroup,
      },
      class: 'modal-lg',
    });
  }

  public openEditConfigurationSettingsByUser(confirmButtonLabel: string = null): Promise<boolean | undefined> {
    if (this.userModel.user.hasPermission("EDIT_PROJECT_OPTIONS")) {
      return this.openEditConfigurationSettingsComponent({
        projectOptionsEditable: true,
        saveAndFinalizeProject: false,
        allowEditOfOptionLabels: true,
        confirmButtonLabel,
      });
    } else if (this.userModel.userProfile.user.hasPermission("VIEW_PROJECT_OPTIONS")) {
      return this.openEditConfigurationSettingsComponent({
        projectOptionsEditable: false,
        saveAndFinalizeProject: false,
        allowEditOfOptionLabels: false,
        confirmButtonLabel,
      });
    } else {
      return Promise.resolve(false);
    }
  }

  public openEditConfigurationSettingsComponent(initialState: Partial<ConfSettingsComponent>): Promise<boolean | undefined> {
    return this.windowService.showModalFinish(ConfSettingsComponent, {
      class: 'modal-lg',
      initialState: initialState,
    });
  }

  public openEditConfigurationOptionPopup(editOption: ProjectOptionVO, currentLocale: string): Promise<ProjectOptionVO | undefined> {
    return this.windowService.showModalFinish(EditConfOptionComponent, {
      initialState: {
        editOption,
        currentLocale,
      },
    });
  }

  public openUserProjectOptionsPopup(): Promise<void> {
    return this.windowService.showModalFinish(ProjectOptionDefComponent, {
      class: 'max-width-900',
    });
  }

  public openEditProjectOptionDefPopup(
    editOption: ProjectOptionDefVO,
    userOptions: ProjectOptionDefVO[],
    langKey: string,
    displayName: string
  ): Promise<boolean | undefined> {
    return this.windowService.showModalFinish(EditProjectOptionDefItemComponent, {
      initialState: {editOption, userOptions, langKey, displayName},
    });
  }

  public openConfidentialNoticePopup(): Promise<void> {
    return this.windowService.showModalFinish(EditNoticeComponent);
  }

  public openWireBridgeInfoPopup(articleUsage: ArticleUsageVO | undefined): void {
    if (!Log.assertExists(articleUsage)) {
      return;
    }
    this.windowService.showModal(WireBridgeInfoComponent, {
      class: `modal-sm`,
      initialState: {
        articleUsage,
      },
    });
  }

  public openSelectArticlePopup(
    articles: ArticleVO[],
    titlePrompt: string = '',
    headerPrompt: string = '',
    useFavoritesCheckBoxVisible: boolean = true,
    ignoreSilentClose: boolean = true
  ): Promise<ArticleVO | null | undefined> {
    return this.windowService.showModalFinish(SelectArticleComponent, {
      class: `modal-fz`,
      initialState: {
        articles,
        titlePrompt,
        headerPrompt,
        useFavoritesCheckBoxVisible,
        ignoreSilentClose,
      },
    });
  }

  public openEditBlockingZone(readonly?: boolean): void {
    this.windowService.showModal(EditBlockingZoneComponent, {
      initialState: {readonly},
    });
  }

  public openEditEmptyZone(readonly?: boolean): void {
    this.windowService.showModal(EditEmptyZoneComponent, {
      initialState: {readonly},
    });
  }

  public openEditNBusbar(busbarArticleUsage: ArticleUsageVO): void {
    this.windowService.showModal(EditNBusbarComponent, {
      initialState: {
        busbarArticleUsage,
      },
    });
  }

  public showRailPropertiesDialog(configuration: RailPropertiesConfiguration): void {
    if (!configuration) {
      return;
    }

    this.windowService.showModalFinish(RailPropertiesComponent, {
      class: 'modal-lg',
      initialState: configuration,
    });
  }

  public openLabelEditorAssistantPopup(
    tableProvider: ITableProvider,
    selectedCells: number[][],
    closeable: boolean,
    isPENOptionsAvailable: boolean,
    symbolPEOptions: Object[],
    symbolNOptions: Object[],
    selectedPENOptions: LabelEditorPENOptions,
    numericFromText: string,
    numericToText: string
  ): Promise<{
    cellLabelList: [number, number, string][],
    selectedPENOptions: LabelEditorPENOptions,
  } | null> {
    return this.windowService.showModalFinish(LabelEditorAssistantComponent, {
      class: 'modal-lea',
      initialState: {
        tableProvider: tableProvider,
        selectedCells: selectedCells,
        closeable: closeable,
        isPENOptionsAvailable: isPENOptionsAvailable,
        symbolPEOptions: symbolPEOptions,
        symbolNOptions: symbolNOptions,
        selectedPENOptions: selectedPENOptions,
        numericFromText: numericFromText,
        numericToText: numericToText,
      },
      keyboard: closeable,
      ignoreBackdropClick: !closeable,
    });
  }

  public showOutdatedArticlesDialog(initialState: Partial<ProjectLoadingOutdatedArticlesComponent>): void {
    this.windowService.showModal(ProjectLoadingOutdatedArticlesComponent, {
      class: 'modal-md',
      initialState: initialState,
    });
  }

  public showCorruptArticlesDialog(): Promise<CorruptArticleAction> {
    return this.windowService.showModalMdFinish(ProjectLoadingCorruptArticlesComponent);
  }

  public openReassignComponent(itemToReassign: ProjectGroupVO | ProjectHeadVO): Promise<ProjectHeadVO | ProjectGroupVO> {
    return this.windowService.showModalFinish(ReassignComponent, {
      initialState: {itemToReassign},
    });
  }

  public openEditProjectVersionComponent(
    projectSaveInfo: ProjectSaveInfoVO,
    configName: string = null,
    selectedProjectGroupProjects: ProjectHeadVO[] = null
  ): Promise<EditProjectVersionResult> {
    return this.windowService.showModalFinish(EditProjectVersionComponent, {
      initialState: {projectSaveInfo, configName, selectedProjectGroupProjects},
    });
  }

  public openEditProjectNameComponent(project: ProjectHeadVO, isArticleProject: boolean): Promise<boolean | undefined> {
    return this.windowService.showModalFinish(EditProjectNameComponent, {
      initialState: {project, isArticleProject},
    });
  }

  public openProjectVersionHistoryComponent(projectHead: ProjectHeadVO, compareItemListMode: boolean = false): Promise<boolean | undefined> {
    return this.windowService.showModalFinish(ProjectVersionHistoryComponent, {
      class: 'max-width-900',
      initialState: {project: projectHead, compareItemListMode},
    });
  }

  public openCompareItemListComponent(project: ProjectVO, projectPath: string): void {
    this.windowService.showModal(CompareItemListsComponent, {
      class: `modal-md`,
      initialState: {projectB: project, projectPathStringB: projectPath},
    });
  }

  public openExportPrintFilePopup(exportType: ExportType): void {
    this.windowService.showModal(ExportPrintFileComponent, {
      class: `modal-md`,
      initialState: {exportType},
    });
  }

  public openPopupActionWithExportPrint(): void {
    this.windowService.showModal(ChoiceActionExportPrintComponent, {
      class: `modal-md`,
    });
  }

  public openEditBmk(): void {
    this.windowService.showModal(EditBmkComponent, {
      class: `modal-md`,
      ignoreBackdropClick: false,
    });
  }

  public async openDrillingHoleWizard(properties: {
    currentMode: EditDrillingHoleMode,
    totalLength: number,
    drillingHoleArticles: ArticleVO[],
    carrierHasPreset: boolean,
    presetStartOffset: number,
    presetDrillingholeDistance: number,
    drillingHoleInfo?: DrillingHoleInfo,
  }): Promise<DrillingHoleInfo | number | DrillingHoleInfo[] | null> {
    if (properties && ArrayUtils.isEmpty(properties.drillingHoleArticles)) {
      await this.alertHelper.showError(
        'editDrillingHolePopup.title.load_drilling_holes_failed',
        'editDrillingHolePopup.message.load_drilling_holes_failed'
      );
      return;
    }
    return this.windowService.showModalFinish(DrillingHoleWizardComponent, {
      initialState: {properties},
    });
  }

  public openWaitForImportPopup(): BsModalRef {
    return this.windowService.showModal(WaitForProServeProjectImportPopupComponent, {
      class: 'modal-md',
    });
  }

  public openIOArticleSettingsTabComponent(articleUsage: ArticleUsageVO | undefined): void {
    this.windowService.showModal(IOArticleSettingsTabComponent, {
      class: `modal-md`,
      initialState: {articleUsage},
    });
  }

  public openEditDescriptionComponent(description: string): Promise<{ success: boolean, data: string }> {
    return this.windowService.showModalFinish(EditDescriptionComponent, {
      class: `modal-md`,
      initialState: {description},
    });
  }

  public showFinalizeProjectPopup(data: Partial<FinalizeProjectComponent>): Promise<boolean> {
    return this.windowService.showModalFinish(FinalizeProjectComponent, {
      initialState: data,
      class: 'modal-lg',
    });
  }

  public showFinalizeLegacyProjectPopup(): Promise<boolean> {
    return this.windowService.showModalFinish(FinalizeLegacyProjectComponent, {
      class: 'modal-lg',
    });
  }

  public showFinalizeRepetitionPopup(project: ProjectVO): Promise<void> {
    return this.windowService.showModalFinish(FinalizeProjectRepetitionComponent, {
      initialState: {
        existingFNumber: project.fNumber,
      },
      class: 'modal-md',
    });
  }

  public showChooseFinalizationActionPopup(): Promise<void> {
    return this.windowService.showModalFinish(ChooseFinalizationActionComponent, {
      class: 'modal-lg',
    });
  }

  public openEditProjectArticleNumberPopup(
    articleNumber: string,
    isAutomaticGenerationAvailable: boolean,
    isAutomaticGenerationSelected: boolean
  ): Promise<{ articleNumber: string, isAutomaticGenerationSelected: boolean }> {
    return this.windowService.showModalFinish(EditProjectArticleNumberComponent, {
      initialState: {
        articleNumber: articleNumber,
        isAutomaticGenerationAvailable: isAutomaticGenerationAvailable,
        isAutomaticGenerationSelected: isAutomaticGenerationSelected,
      },
    });
  }

  public openProjectRequestApprovalDialog(multipleQuoteRequestData: MultipleQuoteRequestData = null): void {
    this.windowService.showModal(ProjectRequestApprovalComponent, {
      class: 'modal-md',
      initialState: {multipleQuoteRequestData},
    });
  }

  public openProjectRequestQuoteTypeDialog(): void {
    this.windowService.showModal(ProjectRequestQuoteTypeComponent, {
      class: 'modal-md',
    });
  }

  public openProjectRequestPriceCalculationDialog(): void {
    this.windowService.showModal(ProjectRequestPriceCalculationComponent, {
      class: 'modal-md',
    });
  }

  public openProjectRequestDialog(
    multipleQuoteRequestData: MultipleQuoteRequestData = null,
    totalDemand?: number,
    batchSize?: number,
    deliveryDate?: Date,
    remarks?: string,
    sapProjectNumber?: string
  ): void {
    this.windowService.showModal(ProjectRequestComponent, {
      class: 'modal-md',
      initialState: {multipleQuoteRequestData, totalDemand, batchSize, deliveryDate, remarks, sapProjectNumber},
    });
  }

  public openProjectRequestUnavailableArticlesPopup(showArticleList: boolean, unavailableArticles: ArticleVO[]): Promise<boolean> {
    return this.windowService.showModalFinish(ProjectRequestUnavailableArticlesComponent, {
      class: 'modal-md',
      initialState: {showArticleList, unavailableArticles},
    });
  }

  public openChooseFinalizationPreselectionDialog(oldData: FinalizationPreselectionVO, newData: FinalizationPreselectionVO): Promise<boolean> {
    return this.windowService.showModalFinish(ChooseFinalizationPreselectionComponent, {
      class: 'modal-md',
      initialState: {oldData, newData},
    });
  }

  public openElbridgeDialog(): void {
    this.windowService.showModal(ElbridgeComponent, {
      class: `modal-md`,
    });
  }

  public openElbridgeInfoDialog(): void {
    this.windowService.showModal(ElbridgeInfoComponent, {
      class: `modal-md`,
    });
  }

  public openSelectCableFedSidePopup(): Promise<void> {
    return this.windowService.showModalFinish(SelectCableFedSidePopupComponent);
  }

  public showFinalizationPreviewApproval(previewReports: ReportVO[],
                                         previewProperties: ReportGenerationPropertyVO[],
                                         previewLocale: string,
                                         previewProjectFinalizationInfo: ProjectFinalizationInfoVO) {
    this.windowService.showModal(FinalizationPreviewApprovalComponent, {
      initialState: {
        previewReports,
        previewProperties,
        previewLocale,
        previewProjectFinalizationInfo
      },
      ignoreBackdropClick: true,
    });
  }

  public showChangeBaseArticle() {
    this.windowService.showModal(ChangeBaseArticleComponent, {
      ignoreBackdropClick: false,
      initialState: {
      },
    });
  }

  public showSelectProjectReport() {
    this.windowService.showModal(SelectProjectReportComponent);
  }

  public showSelectCsvReport() {
    this.windowService.showModal(SelectCsvReportComponent);
  }

  public async openDyeConnectionDialog(): Promise<ColorSelectionOption> {
    return await this.windowService.showModalMdFinish(DyeConnectionComponent);
  }

  public showPreferredSamples(project: ProjectHeadVO): void {
    this.windowService.showModalFz(PreferredSamplesModalComponent, {
      project
    });
  }

  public async showConfigurationConsistentSamples(project: ProjectHeadVO): Promise<ConfigurationConsistentSamplesAction> {
    return await this.windowService.showModalFullscreenFinish(ConfigurationConsistentSamplesComponent, {project});
  }

  public openCsvImportOptions(csvData: CaeData) {
    this.windowService.showModal(CsvImportOptionsComponent, {
      class: `modal-lg`,
      initialState: {csvData},
    });
  }

  public openCsvResult(caeImportErrorCollector: CaeImportErrorCollector) {
    this.windowService.showModal(CsvResultComponent, {
      class: `modal-lg`,
      initialState: {
        caeImportErrorCollector,
      },
    });
  }
}
